export default __webpack_public_path__ + "static/c08-c096025cd0ae6206545a737e81db3ac6.png";